// src/components/strumenti/PortataAria.js — W442. Portata d'aria dai ricambi orari
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, fmt } from "./UiStrumento";
import { portataAria } from "../../utils/calcoliStrumenti";

export default function PortataAria() {
  const { v, set, n, azzera } = useCampi({ l:"", p:"", h:"", vol:"", ric:"" });
  const volume = n("vol") > 0 ? n("vol") : (n("l") > 0 && n("p") > 0 && n("h") > 0 ? n("l") * n("p") * n("h") : NaN);
  const r = portataAria(volume, n("ric"));
  return (
    <div>
      <Griglia colonne={3}>
        <Campo etichetta="Lunghezza (m)" valore={v.l} onChange={set("l")} placeholder="Es. 5"/>
        <Campo etichetta="Larghezza (m)" valore={v.p} onChange={set("p")} placeholder="Es. 4"/>
        <Campo etichetta="Altezza (m)" valore={v.h} onChange={set("h")} placeholder="Es. 3"/>
      </Griglia>
      <Griglia colonne={2}>
        <Campo etichetta="…oppure volume del locale (m³)" valore={v.vol} onChange={set("vol")} placeholder="Es. 60" aiuto="Se lo scrivi, ha la precedenza sulle misure."/>
        <Campo etichetta="Ricambi d'aria all'ora (vol/h)" valore={v.ric} onChange={set("ric")} placeholder="Es. 2" aiuto="Dipende dall'uso del locale e dalla norma applicabile."/>
      </Griglia>
      <Risultato settore="condizionamento" titolo="Portata d'aria" valore={fmt(r?.m3h, 1)} unita="m³/h"
        righe={r ? [["Volume del locale", fmt(volume, 2) + " m³"], ["In litri al secondo", fmt(r.ls, 1) + " l/s"]] : []}/>
      <Formula>Q = V × n (m³/h), con V = lunghezza × larghezza × altezza; l/s = m³/h ÷ 3,6. I ricambi richiesti dipendono dalla destinazione d'uso (es. UNI 10339, regolamenti locali): verificali.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
